<div class="jw-modal">
  <div class="jw-modal-body">
    <ng-content></ng-content>
  </div>
</div>
<div class="jw-modal-background"></div>
